export default {
  errorsRootKey: 'customerActivities',
  resource: 'customerActivities',
  actions: ['index']
}
